import { render, staticRenderFns } from "./AppOrders.vue?vue&type=template&id=e8b72c6c&scoped=true&"
import script from "./AppOrders.vue?vue&type=script&lang=js&"
export * from "./AppOrders.vue?vue&type=script&lang=js&"
import style0 from "./AppOrders.vue?vue&type=style&index=0&id=e8b72c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b72c6c",
  null
  
)

export default component.exports